import { Component, OnInit, Input } from "@angular/core";
import { ConflictosService } from "../servicios/conflictos.service";
import { Globals } from "../../globals";
import Swal from "sweetalert2";

@Component({
  selector: "app-pregunta",
  templateUrl: "./pregunta.component.html",
  styleUrls: ["./pregunta.component.css"]
})
export class PreguntaComponent implements OnInit {
  @Input() tipoPregunta: number;
  @Input() respuestaSeleccionada;

  pregunta = "";
  descripcionPregunta = "";
  instruccionesdellenado = "";
  configCampos;
  mostrar;
  

  constructor(private conflictosService: ConflictosService, public global: Globals) {}

  ngOnInit() {
    let etiquetaCargando={es:"Cargando",en:"Loading"}
    Swal.fire(etiquetaCargando[this.global.lenguaje]);
    Swal.showLoading();
    this.conflictosService.consultarPreguntas(this.tipoPregunta).subscribe(datos => {
      Swal.close();
      //////conole.log("DATOS",datos)
      this.llenarEtiquetas(datos);
      this.mostrar = true;
    });
  }

  llenarEtiquetas(datos) {
    let configConflicto = datos.Conflicto[0];
    this.configCampos = datos.CampoCompleto;
    if (this.global.lenguaje == "es") {
      this.pregunta = configConflicto.preguntaEs;
      this.descripcionPregunta = configConflicto.descripcionEs;
      this.instruccionesdellenado = configConflicto.Instruccionesllenado;
    } else {
      this.pregunta = configConflicto.preguntaEn;
      this.descripcionPregunta = configConflicto.descripcionEn;
      this.instruccionesdellenado = configConflicto.InstruccionesllenadoIngles;
    }
  }
}
